import React from 'react';
interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  stagger?: boolean;
}
export const Reveal: React.FC<RevealProps> = ({
  children,
  className = ''
}) => {
  return <div className={className} data-id="element-494">{children}</div>;
};
export const RevealItem: React.FC<{
  children: React.ReactNode;
  className?: string;
}> = ({
  children,
  className = ''
}) => {
  return <div className={className} data-id="element-495">{children}</div>;
};